import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import VersionHistoryPage from '@/areas/sourcing-scenarios/SourcingScenarios/VersionHistoryPage/VersionHistoryPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/version-history')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <VersionHistoryPage {...pathParams} />;
}
